import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const useUpdateVesselOtherDocuments = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const updateOtherDocuments = async ({ vesselId, documents }) => {
    const formData = new FormData();
    documents.forEach((doc) => {
      formData.append(doc.name, doc.file); 
    });

    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/update/otherDocuments/${vesselId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  };

  return useMutation(updateOtherDocuments, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels");
    },
    onError: (error) => {
      throw new Error(error.response?.data?.message || "Failed to update other documents");
    },
  });
};

export default useUpdateVesselOtherDocuments;
